import { withSvg } from "core/components/svg/Svg";

export const Chevron = withSvg(
    24,
    24
)(() => (
    <path d="M11.9975 8.75012C12.2894 8.75005 12.5668 8.87754 12.7569 9.09914L17.2591 14.3491C17.6186 14.7684 17.5702 15.3997 17.151 15.7592C16.7318 16.1187 16.1004 16.0703 15.7409 15.6511L11.9981 11.2867L8.25944 15.6507C7.90012 16.0701 7.26883 16.1189 6.84941 15.7595C6.43 15.4002 6.38128 14.7689 6.7406 14.3495L11.2384 9.09952C11.4283 8.87783 11.7056 8.75019 11.9975 8.75012Z" />
));
